// extracted by mini-css-extract-plugin
export var typingIndicator = "_ok-0";